import { makeAutoObservable } from 'mobx';
import { ISaveable } from '../../../../../stores/types';
import { ICredentialsStore } from '../integration-store';

export interface ITrengoCredentials {
    api_key: string,
    tickets_channel_id: number,
    email_channel_id: number,
}

class TrengoCredentialsStore implements ISaveable, ICredentialsStore {
    private _changes: ITrengoCredentials = {} as ITrengoCredentials;

    constructor() {
        makeAutoObservable(this);
    }

    public get api_key() { return this._changes.api_key; }
    public get tickets_channel_id() { return this._changes.tickets_channel_id; }
    public get email_channel_id() { return this._changes.email_channel_id; }

    public set api_key(v: string) { this._changes.api_key = v; }
    public set tickets_channel_id(v: number) { this._changes.tickets_channel_id = v; }
    public set email_channel_id(v: number) { this._changes.email_channel_id = v; }

    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }


    /********* ISaveable implementation *************/
    public hasChanges(): boolean {
        return !!Object.keys(this._changes).length;
    }

    public discardChanges(): void {
        this._changes = {} as ITrengoCredentials;
    }

    public getUpdatedModel(): ITrengoCredentials { throw new Error('Not implemented.'); }
    public isSaving(): boolean { throw new Error('Not implemented.'); }
    public commitChanges() { throw new Error('Not implemented.'); }
    public async save() { throw new Error('Not implemented.'); }
}

export default TrengoCredentialsStore;
